const TEAM_IMG =
  "https://images.pexels.com/photos/1181405/pexels-photo-1181405.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

import useScrollReveal, { useStaggerReveal } from "@/hooks/useScrollReveal";

const VALUES = [
  {
    k: "01",
    title: "Excelencia técnica",
    desc: "Cada commit, cada review y cada arquitectura tiene un estándar elevado y no negociable.",
  },
  {
    k: "02",
    title: "Transparencia radical",
    desc: "Reportes claros, presupuestos abiertos y comunicación directa con el equipo de ingeniería.",
  },
  {
    k: "03",
    title: "Foco en negocio",
    desc: "El código es el medio. El objetivo es mover los KPIs de tu empresa de manera medible.",
  },
];

export default function About() {
  const imgRef = useScrollReveal();
  const txtRef = useScrollReveal();
  const valuesRef = useStaggerReveal({ delayStep: 80 });
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="bg-white border-t border-[#E5E5E5]"
    >
      <div className="px-6 md:px-12 lg:px-16 max-w-[1440px] mx-auto py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div ref={imgRef} className="reveal-on-scroll lg:col-span-7 zoom-wrap overflow-hidden border border-[#E5E5E5]">
            <img
              src={TEAM_IMG}
              alt="Equipo multidisciplinario trabajando en oficina moderna"
              className="zoom-img w-full h-[420px] md:h-[560px] object-cover"
              data-testid="about-image"
            />
          </div>

          <div ref={txtRef} className="reveal-on-scroll lg:col-span-5">
            <span className="eyebrow">[ 05 ] Sobre nosotros</span>
            <h2 className="display-2 mt-5 mb-8">
              El equipo detrás del código.
            </h2>
            <p className="text-[#525252] text-base md:text-lg leading-relaxed mb-6">
              En <strong className="text-[#171717]">TI Datos y Sistemas Wok Center </strong>
              combinamos el rigor de la ingeniería con la creatividad del diseño.
              Somos un colectivo multidisciplinario de desarrolladores, diseñadores
              y científicos de datos comprometidos con la excelencia técnica.
            </p>
            <p className="text-[#525252] text-base md:text-lg leading-relaxed mb-10">
              Trabajamos con corporativos, PyMEs ambiciosas y startups que entienden
              que la tecnología no es un gasto: es una palanca de crecimiento.
            </p>

            <div ref={valuesRef} className="grid grid-cols-1 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
              {VALUES.map((v) => (
                <div key={v.k} className="bg-white p-6 md:p-7" data-testid={`about-value-${v.k}`} data-stagger-item>
                  <div className="flex items-baseline gap-4 mb-2">
                    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#A3A3A3]">
                      [ {v.k} ]
                    </span>
                    <h3 className="font-display text-lg md:text-xl font-bold tracking-tight">
                      {v.title}
                    </h3>
                  </div>
                  <p className="text-[#525252] text-[14.5px] leading-relaxed pl-12">
                    {v.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
